import React from 'react';
import { IconPropType } from '../../../../Interfaces/IconPropType';
import { neutral } from '../../../../style/colors';
export const SwatchBook = (props: IconPropType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      onClick={onClick ? () => onClick() : () => { }}
      style={style}
      width={width ? width : height ? height : 100}
      height={height ? height : width ? width : 100}
      viewBox="0 0 18 18"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Screens"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="1---Filter---Farver-efter-anvendelse"
          fill={color ? color : neutral[600]}
          fillRule="nonzero"
        >
          <g id="swatchbook">
            <path
              d="M3.71607296,14.0679905 C4.15569767,14.0679905 4.51237431,13.7113139 4.51237431,13.2716892 C4.51237431,12.8317327 4.15569767,12.4753878 3.71607296,12.4753878 C3.27644826,12.4753878 2.91977161,12.8317327 2.91977161,13.2716892 C2.91977161,13.7113139 3.27644826,14.0679905 3.71607296,14.0679905 Z M15.926027,9.55561619 L12.687403,9.55561619 L14.977433,7.26558623 C15.3921733,6.85084594 15.3921733,6.17863489 14.977433,5.76422639 L11.2235357,2.01032911 C11.0161656,1.80295897 10.7444277,1.6994398 10.4726899,1.6994398 C10.2009521,1.6994398 9.92921424,1.80295897 9.7218441,2.01032911 L7.43214593,4.30035908 L7.43214593,1.06173513 C7.43214593,0.475458264 6.95668766,0 6.37041079,0 L1.06173513,0 C0.475458264,0 0,0.475458264 0,1.06173513 L0,13.2716892 C0,15.3241559 1.66360624,16.9877621 3.71607296,16.9877621 L15.926027,16.9877621 C16.5123039,16.9877621 16.9877621,16.5123039 16.9877621,15.926027 L16.9877621,10.6173513 C16.9877621,10.0310745 16.5123039,9.55561619 15.926027,9.55561619 Z M5.83954323,13.2716892 C5.83954323,13.8649337 5.59368519,14.4007781 5.2001796,14.7863207 C5.07907544,14.9047705 4.94469959,15.002981 4.80236072,15.0865926 C4.77382659,15.1035141 4.74396529,15.1184447 4.71476757,15.1340389 C4.56645645,15.2116783 4.41217306,15.2770414 4.24959487,15.3188472 C4.07839008,15.3636392 3.90187661,15.3948276 3.71673655,15.3948276 L3.71607296,15.3948276 C2.54517819,15.3948276 1.5926027,14.4422521 1.5926027,13.2713574 L1.5926027,10.086152 L5.83954323,10.086152 L5.83954323,13.2716892 Z M5.83954323,8.49388106 L1.5926027,8.49388106 L1.5926027,5.83954323 L5.83954323,5.83954323 L5.83954323,8.49388106 Z M5.83954323,4.24694053 L1.5926027,4.24694053 L1.5926027,1.5926027 L5.83954323,1.5926027 L5.83954323,4.24694053 Z M7.43214593,6.55256473 L10.4730217,3.51168895 L13.4760732,6.51474041 L7.43214593,12.5586677 L7.43214593,6.55256473 Z M15.3951594,15.3951594 L6.84785981,15.3951594 L11.0948003,11.1482189 L15.3951594,11.1482189 L15.3951594,15.3951594 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SwatchBook;
